import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { RegistrationLayout } from 'componets/layouts';
import { Paper } from 'componets/ui';

import { Paths } from 'utils/constants';

import { useAppSelector, useTranslate } from 'hooks';

import { selectUser } from 'selectors';

import styles from '../Register/index.module.scss';

export const VerifyIdentityFailed = () => {
	const user = useAppSelector(selectUser);
	const navigate = useNavigate();

	const t = useTranslate(['verifyLaterText', 'yourVeriffFailedText', 'contactByEmailText']);

	return (
		<RegistrationLayout email={user.email}>
			<Paper styleName={styles.blockForm}>
				<Typography.Title level={4} className={styles.veriffTitle}>
					{t.yourVeriffFailedText}
				</Typography.Title>
				<Typography.Text className={styles.veriffText}>
					<Trans
						i18nKey="getInTouchClientSupportText"
						components={{
							l: (
								<a
									href="mailto:info@crowdpear.com"
									target="_blank"
									className={styles.link}
									rel="noreferrer"
								/>
							),
						}}
					/>
				</Typography.Text>

				<Button type="primary" size="large" block>
					<a
						href="mailto:info@crowdpear.com"
						target="_blank"
						rel="noreferrer"
						className={styles.link}
					>
						{t.contactByEmailText}
					</a>
				</Button>
			</Paper>

			<div className={styles.verifyLater} role="button" onClick={() => navigate(Paths.OVERVIEW)}>
				<Typography.Text type="secondary">{t.verifyLaterText}</Typography.Text>
			</div>
		</RegistrationLayout>
	);
};
